import { Currency, TradeType } from '@uniswap/sdk-core'
import { ReactComponent as GasIcon } from 'assets/images/gas-icon.svg'
import { LoadingOpacityContainer } from 'components/Loader/styled'
import { RowFixed } from 'components/Row'
import { InterfaceTrade } from 'state/routing/types'
import styled from 'styled-components/macro'

const GasWrapper = styled(RowFixed)`
  border-radius: 8px;
  padding: 4px 6px;
  height: 22px;
  color: ${({ theme }) => theme.accentAction};
  font-size: 14px;
  user-select: none;
`
const StyledGasIcon = styled(GasIcon)`
  margin-right: 2px;
  width: 24px;
  height: 24px;
`

export default function GasEstimateBadge({
  gasCostUsd,
  loading,
}: {
  trade: InterfaceTrade<Currency, Currency, TradeType> | undefined | null // dollar amount in active chain's stablecoin
  gasCostUsd: number
  loading: boolean
  showRoute?: boolean // show route instead of gas estimation summary
  disableHover?: boolean
}) {
  const formattedGasPriceString = gasCostUsd ? '$' + parseFloat(gasCostUsd.toFixed(4)) : undefined

  return (
    <LoadingOpacityContainer $loading={loading}>
      <GasWrapper>
        <StyledGasIcon />
        {formattedGasPriceString ?? null}
      </GasWrapper>
    </LoadingOpacityContainer>
  )
}
